export const TRANSPORT_TYPES = [
    {
        value: 1,
        label: "calc-transport-transport-types-cars",
    },
    {
        value: 2,
        label: "calc-transport-transport-types-trucks",
    },
    {
        value: 3,
        label: "calc-transport-transport-types-buses",
    },
    {
        value: 4,
        label: "calc-transport-transport-types-water-transport",
    },
    {
        value: 5,
        label: "calc-transport-transport-types-aircrafts",
    },
    {
        value: 6,
        label: "calc-transport-transport-types-two-wheeled-transport",
    },
    {
        value: 7,
        label: "calc-transport-transport-types-off-road-vehicle",
    },
    {
        value: 8,
        label: "calc-transport-transport-types-railway",
    },
];

export const CAR_VOLUME_TYPES = [
    { value: 1, label: "calc-transport-car-volume-types-1" },
    { value: 2, label: "calc-transport-car-volume-types-2" },
];

export const CAR_IMPORT_DATES = [
    { value: 1, label: "calc-transport-car-import-dates-1" },
    { value: 2, label: "calc-transport-car-import-dates-2" },
];

export const AIR_BOUGHT_DATES = [
    {
        value: 1,
        label: "calc-transport-air-bought-dates-1",
    },
    {
        value: 2,
        label: "calc-transport-air-bought-dates-2",
    },
];

export const VOLUME_RANGES_TYPES = [
    {
        value: 1,
        label: "calc-transport-volume-ranges-types-1",
    },
    {
        value: 2,
        label: "calc-transport-volume-ranges-types-2",
    },
    {
        value: 3,
        label: "calc-transport-volume-ranges-types-3",
    },
    {
        value: 4,
        label: "calc-transport-volume-ranges-types-4",
    },
];

export const MONTH_NUMBERS_TYPES = [
    {
        value: 1,
        label: "1",
    },
    {
        value: 2,
        label: "2",
    },
    {
        value: 3,
        label: "3",
    },
    {
        value: 4,
        label: "4",
    },
    {
        value: 5,
        label: "5",
    },
    {
        value: 6,
        label: "6",
    },
    {
        value: 7,
        label: "7",
    },
    {
        value: 8,
        label: "8",
    },
    {
        value: 9,
        label: "9",
    },
    {
        value: 10,
        label: "10",
    },
    {
        value: 11,
        label: "11",
    },
    {
        value: 12,
        label: "12",
    },
];

export const LOAD_TYPES = [
    {
        value: 1,
        label: "calc-transport-volume-ranges-types-1",
    },
    {
        value: 2,
        label: "calc-transport-volume-ranges-types-2",
    },
    {
        value: 3,
        label: "calc-transport-volume-ranges-types-3",
    },
    {
        value: 4,
        label: "calc-transport-volume-ranges-types-4",
    },
];

export const NUMBER_SEATS_TYPES = [
    {
        value: 1,
        label: "calc-transport-number-seats-types-1",
    },
    {
        value: 2,
        label: "calc-transport-number-seats-types-2",
    },
    {
        value: 3,
        label: "calc-transport-number-seats-types-3",
    },
];

export const MOTOR_POWER_TYPES = [
    {
        value: 1,
        label: "calc-transport-motor-power-types-1",
    },
    {
        value: 2,
        label: "calc-transport-motor-power-types-2",
    },
    {
        value: 3,
        label: "calc-transport-motor-power-types-3",
    },
    {
        value: 4,
        label: "calc-transport-motor-power-types-4",
    },
];

export const MOTOCYCLE_MOTOR_POWER_TYPES = [
    {
        value: 1,
        label: "calc-transport-motocycle-motor-power-types-1",
    },
    {
        value: 2,
        label: "calc-transport-motocycle-motor-power-types-2",
    },
];
